/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import * as moment from 'moment';
import { connect } from 'react-redux';
import { staticContentsImagePath as BASE_IMAGE_PATH } from '../configs/const';

class SinglePageUnderMaintenance extends Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    // pageOrReport={'Report'} maintananceDuration={'24 to 48 hrs'}
    render() {
        return (
            <>
                <div className='pgundr alllbl-maintenance'>
                    <div className='maintenance-box'>
                        <div className='pgundr maintenance-images'><img src={BASE_IMAGE_PATH + "/casino/banner/images/under-maintenance-all-lbl.jpg"} alt=''></img></div>
                        <div className='pgundr maintenance-title'>{this.props.pageOrReport} is UnderMaintenance for {this.props.maintananceDuration}</div>
                        <div className='maintenance-p'>SORRY FOR THE INCONVENIENCE!</div>
                    </div>
                </div>
            </>
            )
    }
}

function mapStateToProps(state) {
    return {
    };
}

function mapDispatchToProps(dispatch) {
    return {
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(SinglePageUnderMaintenance);